<template>
    <div class="box">
        <h3 class="title is-4">Main Driver's details</h3>
        <div class="columns is-multiline">
            <div class="column" v-bind:class="[ item.title.substr(0,5) == 'Claim' ? 'is-12' : 'is-6' ]" v-for="item in drivers_details" :key="item.title">
                <p><strong>{{ item.title }}</strong></p>
                <template v-if="Array.isArray(item.value)">
                    <div class="mb-4" v-for="subitem in item.value" :key="subitem.index">
                    <div v-html="subitem"></div>
                    </div>
                </template>
                <template v-else>
                    <div v-html="item.value"></div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { fulltextDate } from '@/helpers/dateHelper.js'

export default {
  components: {
  },
  props: {
    
  },
  computed: {
    ...mapGetters({
      answers: 'flattenedAnswers',
      answerLabel: 'getAnswerLabel',
      getAnswer: 'getAnswer',
      client: 'client',
      getStep: 'getStep',
    })
  },

  mounted () {
      // we can check that we have data ready to go
      // this is at the start because it results in an axios call which will fail
      // then is caught by the axios interceptor and will redirect to error page

      const claims = this.answers[this.getStep('DriverClaimHistory')];
      const selected_driver = this.answers[this.getStep('Confirm')].vehicle_confirm_driver;

      if( selected_driver === "new-driver"  ) {
      const driver_name = this.getAnswer('DriverDetails', 'driver_details_first_name') + ' ' + this.getAnswer('DriverDetails', 'driver_details_last_name');
      this.drivers_details = [
          { title: "Name of main driver", value:driver_name },
          { title: "Birthdate", value: fulltextDate(this.answers[this.getStep('DriverDetails')].driver_details_dob) },
          { title: "Claim history (5 years)", value: [] },
      ];

      if ( this.answers[this.getStep('Confirm')].vehicle_confirm_driver_claim_count > 0 ) {
          // claims

          for( let $j = 1; $j <= this.answers[this.getStep('Confirm')].vehicle_confirm_driver_claim_count; $j++ ) {
          let date = new Date( this.answers[this.getStep('DriverClaimHistory')]['claim_full_date_' + $j] );

          this.drivers_details[2].value.push(
              '<span class="month">' + date.toLocaleDateString('en-NZ', { month: 'short' }) + '</span>, ' +
              '<span class="year">' + date.getFullYear() + '</span> - ' +
              this.answerLabel('DriverClaimHistory','claim_type_' + $j) + ' with ' +
              this.answerLabel('DriverClaimHistory','claim_damage_severity_' + $j).toLowerCase() + ' and an excess was paid'
              );
          }
      } else {
          // no claims
          this.drivers_details[2].value.push(
          '<p>No claims where an excess was paid</p>'
          );
      }
      } else if( this.client.drivers.find(element => element.driver_id === parseInt(selected_driver) )  ) {
      const existing_driver = this.client.drivers.find(element => element.driver_id === parseInt(selected_driver) ); // how do I stop the repeated question
      this.drivers_details = [
          { title: "Name of main driver", value: `${existing_driver.first_name} ${existing_driver.last_name}` },
          { title: "Birthdate", value: fulltextDate(existing_driver.dob) }
      ];
      }
  },

  methods: {
      fulltextDate,
      
  },
  data: function () {
      return {
        drivers_details: [],
      }
  }
}
</script>